import { render, staticRenderFns } from "./PageSharedAccess.vue?vue&type=template&id=2eea9c5f&"
import script from "./PageSharedAccess.vue?vue&type=script&lang=js&"
export * from "./PageSharedAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eea9c5f')) {
      api.createRecord('2eea9c5f', component.options)
    } else {
      api.reload('2eea9c5f', component.options)
    }
    module.hot.accept("./PageSharedAccess.vue?vue&type=template&id=2eea9c5f&", function () {
      api.rerender('2eea9c5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shared-access/PageSharedAccess.vue"
export default component.exports